import styled from 'styled-components';

export const Text = styled.div`
  overflow-wrap: anywhere;
  user-select: text;
`;
